// Copyright (c) 2016 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import {
    deleteComponent,
    getComponentDetails
} from '../../shared/repositories';
import TimestampUser from '@deere/cps-it.warranty-model-factory/lib/timestamp-user';
import actions from '../../actions-list';
import {successAlertBar} from '../../../shared/services/alert-bar';
import {translate} from '../../../shared/services/translation-service';

export const updateComponents = pin =>

    async dispatch => {

        dispatch(busyCounter.increaseBusyCounter());

        try {

            const payload = await getComponentDetails(pin);

            dispatch({
                payload,
                property: 'components',
                type: actions.UPDATE_PRODUCT_COMPONENTS_SUCCESS
            });

        } catch (error) {

            throw error;

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };

export const deleteProductComponent = (pin, id, component) =>

    async (dispatch, getState) => {

        dispatch(busyCounter.increaseBusyCounter());

        try {

            const createdBy = new TimestampUser({
                firstName: getState().user.details.firstName,
                id: getState().user.details.id,
                lastName: getState().user.details.lastName
            });

            component.createdBy = createdBy;
            await deleteComponent(pin, id, component);

            successAlertBar(translate('COMPONENT_DELETED_SUCCESSFULLY'));

            updateComponents(pin)(dispatch);

        } catch (error) {

            throw error;

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };



// WEBPACK FOOTER //
// ./src/product/details/action-creators/components.js